import React, { useState, useEffect, useContext } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { AuthContext } from '../lib/AuthContext';

const PublicBookingPage = () => {
  const { linkId } = useParams();
  const navigate = useNavigate();
  const { accessToken, user } = useContext(AuthContext);
  const [linkDetails, setLinkDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLinkDetails = async () => {
      const url = accessToken
        ? `https://quirkleai.com/api/checkout-link/${linkId}/`
        : `https://quirkleai.com/api/public/checkout-link/${linkId}/`;
      
      const headers = accessToken ? { 'Authorization': `Bearer ${accessToken}` } : {};

      try {
        const response = await axios.get(url, { headers });
        setLinkDetails(response.data);
      } catch (err) {
        setError('This booking link is either invalid or has expired.');
        console.error('Error fetching link details:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchLinkDetails();
  }, [linkId, accessToken]);

  const handleBookNow = () => {
    // Logic to proceed with booking, e.g., redirect to a payment page
    // or open a booking confirmation modal.
    // For now, let's just navigate to the book session page.
    navigate(`/book-session/${linkDetails.therapist.id}`);
  };

  if (loading) {
    return <div className="text-center py-10">Loading booking details...</div>;
  }

  if (error) {
    return <div className="text-center py-10 text-red-600">{error}</div>;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      {linkDetails && (
        <Card className="w-full max-w-md shadow-lg">
          <CardHeader>
            <CardTitle className="text-center text-2xl font-bold text-gray-800">Book a Session</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="border-b pb-4">
              <h3 className="font-semibold text-lg">{linkDetails.service.name}</h3>
              <p className="text-gray-600">with {linkDetails.therapist.first_name} {linkDetails.therapist.last_name}</p>
            </div>
            
            <div className="flex justify-between items-center text-lg">
              <span className="font-medium">Price:</span>
              <span className="font-bold">₹{linkDetails.service.price}</span>
            </div>
            
            <div className="flex justify-between items-center text-lg">
              <span className="font-medium">Duration:</span>
              <span className="font-bold">{linkDetails.service.duration}</span>
            </div>

            <div className="pt-4 text-center">
              {user && user.role === 'client' ? (
                <Button asChild className="w-full">
                  <Link to={`/book-session/${linkId}`}>Book Now</Link>
                </Button>
              ) : (
                <>
                  <p className="text-gray-600 mb-4">To continue, please log in or create an account.</p>
                  <div className="flex justify-center gap-4">
                    <Button asChild>
                      <Link to="/login">Login</Link>
                    </Button>
                    <Button asChild variant="outline">
                      <Link to="/register">Register</Link>
                    </Button>
                  </div>
                </>
              )}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default PublicBookingPage;